/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import './taxCalculationTabContent.scss';
import PropTypes from 'prop-types';
import LinearProgress from 'material-ui/LinearProgress';

const dateTimeDelimiter = 11;
export default class TaxCalculationTabContent extends Component {

	constructor(props){
		super(props);
		this.state = {
			selectedTabId: 0
		};
	}
	
	componentDidMount() {
		this.props.logActions.fetchGTDLogs(this.props.invoice.id);
	}

	componentWillReceiveProps(nextProps) {
		if ( this.props.fetchingGTDLogs && !nextProps.fetchingGTDLogs && nextProps.gtdLogs.length > 0) {
			this.setState({ selectedTabId: nextProps.gtdLogs[0].id });
		} 
	}
		
	handleRetrieveGtdLogs(logId) {
		if ( this.state.selectedTabId !== logId) {
			this.props.logActions.fetchGetReqsResp(logId);
		}
		this.setState({ selectedTabId: logId });
	}

	formatJSONResponse(message) {
		return JSON.stringify(message, null, 2);
	}

	
  render() {
  	const { gtdLogInformation, fetchingGTDLogs, fetchingSelectedLogInformation, gtdLogs } = this.props;
    return (
      <div className="tax-calculation-tab">
        <h1 className="tax-calculation-tab__title">Tax Calculation History</h1>
        <div className={ `generic-grid__main-container${ fetchingGTDLogs ? ' blur-content' : '' }` }>
          {
            fetchingGTDLogs && gtdLogs && gtdLogs.length > 0 &&
            <LinearProgress mode="indeterminate" />
          }
          {
            fetchingSelectedLogInformation &&
            <LinearProgress mode="indeterminate" />
          }
        <div className="tax-calc__container">
          {
            gtdLogs && gtdLogs.length === 0 && !fetchingGTDLogs &&
            <h1 className="no-logs-display">There are no GTD logs to display</h1>
          }
          {
            gtdLogs &&
            gtdLogs.map( (log, index) => (
              <section key={ `${log.creationDate}${index}` } id={ `section${index}` }>
                <input
                  type="radio"
                  name="sections"
                  id={ `option${log.creationDate}${index}` }
                  defaultChecked={ index === 0 }
                  onClick={ () => this.handleRetrieveGtdLogs(log.id) }
                />
                <label htmlFor={ `option${log.creationDate}${index}` }>
                  <span style={ { fontWeight: 'bolder ', paddingRight: 10 } }>
                    { log.creationDate.substr(0, dateTimeDelimiter) }
                  </span>
                  <span>
                    {log.creationDate.substr(dateTimeDelimiter)}
                  </span>
                </label>
                <article>
                  <div>
                    <h2>Request Body</h2>

                    <p className={ `${fetchingSelectedLogInformation ? 'blur-content' : ''}` }>
                      { this.formatJSONResponse(gtdLogInformation.request) }
                    </p>
                  </div>
                  <div>
                    <h2>Response Body</h2>
                    <p className={ `${fetchingSelectedLogInformation ? 'blur-content' : ''}` }>
                      { this.formatJSONResponse(gtdLogInformation.response) }
                    </p>
                  </div>
                </article>
              </section>
            ))
          }
          </div>
        </div>
      </div>
    );
  }
}

TaxCalculationTabContent.propTypes = {
	gtdLogInformation: PropTypes.object,
	invoice: PropTypes.object,
	fetchingGTDLogs: PropTypes.bool,
	fetchingSelectedLogInformation: PropTypes.bool,
	gtdLogs: PropTypes.array,
	logActions: PropTypes.shape({
		fetchGTDLogs: PropTypes.func,
		fetchGetReqsResp: PropTypes.func
	})
};



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/taxCalculationTabContent/TaxCalculationTabContent.js